function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 19v3H2v-3c0-.55.45-1 1-1h18c.55 0 1 .45 1 1z",
  stroke: "#fff",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M8 11H4v7h4v-7z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 11H8v7h4v-7z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M16 11h-4v7h4v-7z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20 11h-4v7h4v-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 22.75H1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h22c.41 0 .75.34.75.75s-.34.75-.75.75zm-1.63-17l-9-3.6c-.2-.08-.54-.08-.74 0l-9 3.6c-.35.14-.63.55-.63.93V10c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V6.68c0-.38-.28-.79-.63-.93zM12 8.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})));